import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs009-card-III',
    templateUrl: './rs009-card-III.component.html'
})

export class Rs009CardIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public userLogged?: string;
    public disableCheckbox?: boolean;

    @Output() objMakeCalculations = new EventEmitter();
    @Output() objMakeCalculationsPreBasica = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Etapa 3', false);


        // Formulario v1.0...
        // this.formulario = this.formBuilder.group({
        //     // Descarte_Graos: [null, []],
        //     Sementes_Quebradas: [null, []],
        //     Out_Cultivares: [null, []],
        //     Sementes: [null, []],
        //     Sub_Total_Desc_Grao_g: [null, []],
        //     Sub_Total_Desc_Grao_porc: [null, []],
        //     Sem_Redond: [null, []],
        //     Fracao_Sem: [null, []],
        //     Semente_Peneira: [null, []],
        //     Semente_Redonda: [null, []],
        //     Sem_Pen_Intermediaria: [null, []],
        //     Sem_Pen_Fundo: [null, []]
        // });

        // Formulario v1.1...
        // this.formulario = this.formBuilder.group({
        //     Sementes_Quebradas: [null, []],
        //     Out_Cultivares: [null, []],
        //     Sementes: [null, []],
        //     Sub_Total_Desc_Grao_g: [null, []],
        //     Sub_Total_Desc_Grao_porc: [null, []],
        //     Umidade_Direcionamento: [null, []],
        //     Umidade: [null, []],
        //     Umidade_Deduzir: [null, []],
        //     Desc_Impu_Palh: [null, []],
        //     Desc_Sabugo: [null, []],
        //     Total_Desc_Pal_Imp_Sabugo: [null, []],
        //     Peso_Liquido_Umido: [null, []],
        // });

        // Formulario v1.2...

        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Palha_Impurezas_Outras: [null, []],
                Desc_Palh_Imp_Ardi_Escler: [null, []],
                Qtde_Palh_Imp_Ardi_Escl: [null, []],
                Qtde_Palha: [null, []],
                Qtde_Sabugo: [null, []],
                Desc_Palh_Imp: [null, []],
                Peso_Graos_Amostra: [null, []],
                Qtde_Impurezas: [null, []],
                Sementes: [null, []],
                Sub_Total_Desc_Grao_g: [null, []],
                Sub_Total_Desc_Grao_porc: [null, []],
                Umidade_Deduzir: [null, []],
                Desc_Impu_Palh: [null, []],
                Desc_Sabugo: [null, []],
                Total_Desc_Pal_Imp_Sabugo: [null, []],
                Peso_Liquido_Umido: [null, []],
                Desconto_Umidade: [null, []],
                Peso_Liquido_Seco: [null, []],
                Rendimento_Rw: [null, []],
                validacao: [false, []],
                criado_por: [null, []],
                resp_validacao: [this.userLogged, []],
            });
            this.formulario.get("Qtde_Palha")['warning'] = false;
            this.formulario.get("Qtde_Sabugo")['warning'] = false;
            this.formulario.get("Qtde_Impurezas")['warning'] = false;
            this.formulario.get("Rendimento_Rw")['warning'] = false;
        }
        else {
            this.formulario = this.formBuilder.group({
                palha_impureza_cerar: [null, [Validators.required]],
                sabugo_cerar: [null, [Validators.required]],
                semente_cerar: [null, [Validators.required]],
                palha_amostra: [null, [Validators.required]],
                peso_liquido_carga_umidade: [null, [Validators.required]],
                palha_na_carga: [null, [Validators.required]],
                previsao_mpl_kg: [null, [Validators.required]],
                previsao_mpl_porcento: [null, []],
                previsao_ds_graos_kg: [null, []],
                previsao_ds_graos_porcento: [null, [Validators.required]],
                perda_processo: [null, []]
            });

        }
    }

    async ngOnInit(): Promise<void> {
        await this.makeCalculations();
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    public makeCalculationsPreBasica($event) {
        this.objMakeCalculationsPreBasica.emit();
    }

    public showOptions(event: MatCheckboxChange): void {
        this.formulario.get('validacao').setValue(event.checked);
        if (event.checked) {
            this.formulario.get('resp_validacao').setValue(this.userLogged);
        } else {
            this.formulario.get('resp_validacao').reset();
        }
    }
}

